import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';
import { Steps } from 'antd';


import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';
import Modaladdwork from './Modaladdwork';
import Modaladdlist from './Modaladdlist';
import Modaladdworkedit from './Modaladdworkedit';
import NumberFormat from 'react-number-format';
import Modaladdworkpay from './Modaladdworkpay';
import { Bar } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";

const { Step } = Steps;



export default class Pageworkreport extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',

                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],
                workreport:[],
                stap1:'',
                stap2:'',
                stap3:'',
                stap4:'',
                stap5:'',
            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getworkreport = this.getworkreport.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttographic = this.senttographic.bind(this);
            

            
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

        //  getscore (){
        //     api.get('selectauthscore.php?id_authorities='+localStorage.getItem('id_authorities'))
        //     .then(res => {
        //     //  console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ authscore: res.data})
        //     }) 
        // }

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = '/sorlalum/Checkstudentlist/'+id;

        }

        getworkreport (){
            api.get('selectreport.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
             // this.setState({ workreport: res.data})
              this.setState({ stap1: res.data[0].stap1, stap2: res.data[0].stap2,
                stap3: res.data[0].stap3 ,stap4: res.data[0].stap4, stap5: res.data[0].stap5 })
            }) 
        }

       

        senttographic(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายกราฟฟิก",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttographic.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายกราฟฟิกสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/kprurun2021'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
        //this.getExpert()
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = '/sorlalum'
            } else {
  
            }
              this.getworkreport();
             // this.getstucount();
          }
        

 

    render() {
     // console.log(this.state.code)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;
let dss;
//            const date = year + '-' + month + '-' + day;
     //console.log(date)
     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'รหัส',
            field: 'OLDID',
            sort: 'OLDID',
            width: 270
          },
          {
            label: 'ชื่องาน',
            field: 'NAME',
            sort: 'NAME',
            width: 200
          },
           {
            label: 'วันที่เพิ่ม',
            field: 'DATES',
            sort: 'DATES',
            width: 200
          },
          {
            label: 'จำนวนเงิน',
            field: 'FACULTY',
            sort: 'FACULTY',
            width: 100
          },
          {
            label: 'ตรวจสอบ',
            field: 'check',
            sort: 'check',
            width: 100
          }

        ],

        rows: [...this.state.work.map((data, i) => (
          {
             list: <>{i+1}</>,
             OLDID: <>{data.code_workorder}</>,
             NAME: <>{data.name_workorder}<div> <br/>
                  <Steps size="small" current={data.statusfinish_workorder}>
                  <Step title="รับงาน" description={data.dateadd_workorder.substring(0, 10)} />
                  <Step title="กราฟฟิก"description={data.datesentgf_workorder} />
                  <Step title="ผลิต" description={data.datesentmf_workorder} />
                  <Step title="เสร็จสิ้น" description={data.datefinish_workorder} />
                  <Step title="ชำระเงิน" description={data.datepayfinish_workorder} />
                  </Steps>
            </div></>,
             DATES: <>{data.dateadd_workorder}</>,
             FACULTY: <><NumberFormat value={data.price_workorder}  displayType={'text'} thousandSeparator={true}  /></>,
             check: <>
             {data.statusfinish_workorder === '4' ?<>
              <Modaladdworkpay id_workorder={data.id_workorder} getwork={this.getwork} />
              </>:<>
              {data.statusfinish_workorder === '5' ?<>
             <p className="teal-text">ชำระเงินแล้ว </p>
              </>:<>
               <Modaladdlist code={data.code_workorder} name_workorder={data.name_workorder} 	id_workorder={data.id_workorder}   /> 
                <Modaladdworkedit id_workorder={data.id_workorder} />
                {data.statussentgf_workorder == 1 ?<></>:<> <MDBBtn color="dark-green" size="sm" value={data.id_workorder} onClick={this.senttographic} ><MDBIcon icon="share-square" /> ส่งไปยังกราฟฟิก</MDBBtn></>}
              </>}
              
              </>}
         
             </>,

            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   // searching ={true}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={20}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>




      const  statechat = {
        dataBar: {
          labels: ["รับงาน", "กราฟฟิก", "ผลิต", "เสร็จสิ้น", "ชำระเงิน"],
          datasets: [
            {
              label: "% of Votes",
              data: [this.state.stap1, this.state.stap2, this.state.stap3, this.state.stap4, this.state.stap5],
              backgroundColor: [
                "rgba(255, 134,159,0.4)",
                "rgba(98,  182, 239,0.4)",
                "rgba(255, 218, 128,0.4)",
                "rgba(113, 205, 205,0.4)",
                "rgba(170, 128, 252,0.4)"
              ],
              borderWidth: 2,
              borderColor: [
                "rgba(255, 134, 159, 1)",
                "rgba(98,  182, 239, 1)",
                "rgba(255, 218, 128, 1)",
                "rgba(113, 205, 205, 1)",
                "rgba(170, 128, 252, 1)"
              ]
            }
          ]
        },
        barChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                barPercentage: 1,
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  display: true,
                  color: "rgba(0, 0, 0, 0.1)"
                },
                ticks: {
                  beginAtZero: true
                }
              }
            ]
          }
        }
      }
    
    

        return (
       
                <MDBContainer fluid >
  <h2 className="font-weight-bold  text-center">  รายงานสรุปจำนวนสถานะ</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ดูแลระบบ</p>
      <MDBRow >
          <div >
              {/* <Modaladdwork/>  */}
          </div>
       
        <MDBCol md="8" className="d-flex justify-content-center">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                    <MDBCardBody>
                    <MDBCardTitle className="text-center">  รายการ</MDBCardTitle>
                    <br/>
                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                    </div>
                     {/* {persons} */}
                     <Bar data={statechat.dataBar}  />
                    </MDBCardBody>

                   
         </MDBCard>
        </MDBCol>
        <MDBCol md="4" >
        <MDBRow >
                          <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                                                <MDBCardBody>
                                                <MDBCardTitle className="text-center">  รายการ</MDBCardTitle>
                                                <br/>
                                                <div className='text-center'>
                                                <Pie  data={statechat.dataBar}  />
                                                </div>
                                            
                                                </MDBCardBody>
                                    </MDBCard>
        </MDBRow>
                 
        <MDBRow >
             <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                                <MDBCardBody>
                                <MDBCardTitle className="text-center">  จำนวนสถานะ</MDBCardTitle>
                                <br/>
                                <div className='text-center'>
                                <MDBTable>
      <MDBTableHead>
        <tr>
          <th>รายการ</th>
          <th>จำนวน</th>
        </tr>
      </MDBTableHead>
      <MDBTableBody>
        <tr>
          <td>รับงาน</td>
          <td>{this.state.stap1}</td>
        </tr>
        <tr>
          <td>กราฟฟิก</td>
          <td>{this.state.stap2}</td>
        </tr>
        <tr>
          <td>ผลิต</td>
          <td>{this.state.stap3}</td>
        </tr>
        <tr>
          <td>เสร็จสิ้น</td>
          <td>{this.state.stap4}</td>
        </tr>
        <tr>
          <td>ชำระเงิน</td>
          <td>{this.state.stap5}</td>
        </tr>
      </MDBTableBody>
    </MDBTable>
                                </div>
                             
                                </MDBCardBody>
                    </MDBCard>
        </MDBRow>
                   
        </MDBCol>

      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>

    


                   
                    </MDBContainer>
                   
     
        )
    }
}
